import React from "react";
import { mq, prefix } from "../util";

const ContentSection = ({ frontmatter, html }) => {
  const { title, image } = frontmatter;

  return (
    <div
      css={mq({
        display: [null, "grid"],
        padding: ["0 12px", "0 20px", 0],
        margin: "0 auto",
        marginBottom: [20, 38],
        width: "100%",
        maxWidth: [null, 1146],
        gridTemplateColumns: "2fr 1fr",
        gap: 48,
      })}>
      <div>
        <img
          src={prefix(image)}
          alt={title}
          css={mq({
            width: "100%",
          })}
        />
      </div>
      <div
        css={mq({
          width: [236, "auto"],
          margin: ["20px auto 0", "0"],
          paddingBottom: [14, 0],
        })}>
        <h3
          css={mq({
            fontSize: [24, 34],
            marginBottom: [14, 30],
          })}>
          {title}
        </h3>
        <section
          dangerouslySetInnerHTML={{ __html: html }}
          css={mq({
            fontSize: [null, 21],
          })}
        />
      </div>
    </div>
  );
};

export default ContentSection;
